import React from 'react';
import { useTranslation } from 'react-i18next';

function Navbar2() {
  const { t, i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const LANGUAGE_SWITCH = [
    { label: t('language.en'), code: 'en' },
    { label: t('language.bg'), code: 'bg' },
  ];

  return (
    <nav className="navbar navbar-expand-lg navbar-light inner-navbar-style1">
      <div className="container-fluid">
        <a className="navbar-brand me-lg-5" href="#">
          <img src="/innerpages/assets/img/logo.png" alt="" className="logo" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="#">
                {t('common.home')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                {t('common.studio')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                {t('common.cases')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                {t('common.news')}
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                {t('navigation.contact')}
              </a>
            </li>
          </ul>
          <div className="nav-side">
            {LANGUAGE_SWITCH.map((lang, index) => (
              <a 
                href="#" 
                className={`icon ms-3 ${i18n.language === lang.code ? 'active' : ''}`} 
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  changeLanguage(lang.code);
                }}
                style={{
                  opacity: i18n.language === lang.code ? 1 : 0.7,
                  fontWeight: i18n.language === lang.code ? 'bold' : 'normal'
                }}
              >
                <span>{lang.label}</span>
              </a>
            ))}
            <a href="#" className="icon ms-5 fsz-21 search_btn">
              <span>
                {' '}
                <i className="la la-search"></i>{' '}
              </span>
            </a>
            <div className="nav-search-box">
              <div className="form-group">
                <input type="text" placeholder={t('search.searchWord')} />
                <button>
                  {' '}
                  <i className="fal fa-search"></i>{' '}
                </button>
              </div>
            </div>
            <a
              href="#"
              className="icon ms-3 side_menu_btn fsz-21 active d-none d-lg-inline-block"
            >
              <span>
                {' '}
                <i className="la la-grip-lines"></i>{' '}
              </span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar2;
